import Link from 'next/link';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

export default function NoResult() {
  return (
    <div className={cx('NoResult')}>
      <h5 className={cx('title')}>검색된 항공편이 없습니다</h5>
      <p className={cx('txt')}>
        선택하신 조건으로 검색된 항공편이 없습니다
        <br />
        다른 조건으로 다시 검색해주세요
      </p>
      <Link href="/">
        <button className={cx('confirm')} type="button">
          항공권 홈
        </button>
      </Link>
    </div>
  );
}
